import { nextTick, Ref } from 'vue'

/** CmTable / CmPage（同组件）根实例上的列表刷新方法 */
export type CmTableListRef = {
  getList?: (...args: unknown[]) => void | Promise<unknown>
}

/**
 * 筛选项或与表格同源 `v-model` 变更后刷新列表：先 `nextTick` 再 `getList`，避免合并参数仍为上帧数据。
 * 页面内统一调用 `refreshList`（必要时传入与 `CmTable.getList(outParams?, loadingMore?)` 相同的参数），避免散落 `tableRef.value?.getList()`。
 */
export function useCmTableListRefresh (tableRef: Ref<CmTableListRef | null | undefined>) {
  async function refreshList (...args: unknown[]) {
    await nextTick()
    const gl = tableRef.value?.getList
    if (!gl) return
    await gl.apply(tableRef.value, args)
  }
  return { refreshList }
}
